import { KLEAR_SUPPORT_EMAIL } from '@klear/constants/email'

const STRIPE_SUPPORT_EMAIL_RE = /support@stripe\.com/gi
const STRIPE_SUPPORT_URL_RE = /https?:\/\/support\.stripe\.com\S*/gi

export const VERIFICATION_SUPPORT_CONTACT_SUFFIX = `Please contact ${KLEAR_SUPPORT_EMAIL} for assistance.`

export const VERIFICATION_UNAVAILABLE_FALLBACK =
  'Bank account verification can no longer be completed. Please contact support to restart verification.'

export const VERIFICATION_EXHAUSTED_ATTEMPTS_FALLBACK =
  'All verification attempts have been exhausted. Please contact support to add a new bank account.'

export const VERIFICATION_CANCELED_FALLBACK =
  'Your bank account verification was canceled. Please contact support to restart verification.'

export function userFacingVerificationErrorMessage(rawMessage: string | null | undefined, fallback: string): string {
  const base = (rawMessage?.trim() || fallback).trim()
  const normalized = base
    .replace(STRIPE_SUPPORT_EMAIL_RE, KLEAR_SUPPORT_EMAIL)
    .replace(STRIPE_SUPPORT_URL_RE, KLEAR_SUPPORT_EMAIL)

  if (normalized.includes(KLEAR_SUPPORT_EMAIL)) {
    return normalized
  }

  return `${normalized} ${VERIFICATION_SUPPORT_CONTACT_SUFFIX}`
}
